
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './header';
import Footer from './footer';
import SideMenu from './sideMenu';
import Home from './home';
import About from './about';
import PresetsLuts from './presetsluts';
import Portfolio from './portfolio';
import Contact from './contact';
/*import BrandContentGallery from './brandcontent';
import FashionGallery from './fashion';
import SelfcareMakeup from './selfcaremakeup';
import MyAesthetic from './myaesthetic';
import Switzerland from './switzerland';
import Italy from './italy';*/
import Travel from './travel';
import TravelGallery from './travelgallery';
import PortfolioGallery from './portfoliogallery';

function App() {
  return (
    <Router>
      <Header />
      <SideMenu />
      <Routes>
        <Route path="/" element={<Home />} /> {/* Pagina Home */}
        <Route path="/about" element={<About />} /> {/* Pagina About */}
        <Route path="/presetsluts" element ={<PresetsLuts />} />
        <Route path="/travel" element ={<Travel />} />
        <Route path="/portfolio" element ={<Portfolio />} />
        <Route path="/contact" element ={<Contact />} />
        <Route path="/travel/:country" element={<TravelGallery />}/>
        <Route path="/portfolio/:portfolioCategory" element={<PortfolioGallery/ >}/>
      </Routes>
      <Footer />
    </Router>
    
  );
}

export default App;